<div
  class="tw-w-full tw-px-2 lg:tw-px-7 tw-py-5 tw-bg-white tw-justify-between tw-items-center tw-inline-flex"
>
  <div class="tw-flex tw-gap-10">
    <cohrex-button
      (click)="setCollapsed()"
      color="primaryLink"
      class="tw-justify-center tw-items-center tw-flex"
    >
      <div
        class="tw-w-3 tw-h-3 tw-px-[3px] {{
          collapsed ? 'tw-origin-center tw-rotate-180' : 'tw-origin-top-left'
        }} tw-rounded tw-justify-center tw-items-center tw-flex tw-cursor-pointer "
      >
        <div
          class="material-icons tw-visible lg:tw-hidden {{
            sideNavHidden ? 'tw-visible' : '!tw-hidden'
          }}"
        >
          menu
        </div>
        <div class="material-icons tw-hidden lg:tw-block">
          keyboard_arrow_left
        </div>
      </div>
    </cohrex-button>
    <!-- customer switcher -->
    @if (customerSwitched) {
      <div
        class="tw-min-w-[340px] tw-px-6 tw-py-4 tw-bg-white tw-rounded-lg tw-shadow tw-border tw-border-green-500 tw-justify-start tw-items-center tw-gap-6 tw-inline-flex"
      >
        <div
          class="tw-grow tw-shrink tw-basis-0 tw-h-6 tw-justify-start tw-items-center tw-gap-4 tw-flex"
        >
          <!-- <div
          class="w-6 h-6 rounded-full border-2 border-sky-500 justify-center items-center tw-flex"
          >
          <img
            class="w-6 h-6 rounded-full"
            src="https://via.placeholder.com/24x24"
            alt="Customer Logo"
            />
        </div> -->
          <div
            class="tw-grow tw-shrink tw-basis-0 tw-text-blue-800 tw-text-sm tw-font-semibold tw-font-['Lato']"
          >
            {{ activeCustomer?.name }}
          </div>
        </div>
        <div
          class="tw-w-11 tw-px-2 tw-py-1 tw-bg-green-200 tw-rounded-xl tw-justify-center tw-items-center tw-gap-2 tw-flex"
        >
          <div
            class="tw-text-green-900 tw-text-[10px] tw-font-normal tw-font-['Lato']"
          >
            {{ 'topNav.active' | translate }}
          </div>
        </div>
        <cohrex-button
          color="primaryLink"
          (click)="handleDeactiveActiveCustomer()"
          ><div class="material-icons tw-text-blue-500 tw-text-[24px]">
            cancel
          </div></cohrex-button
        >
      </div>
    }
  </div>
  <div class="tw-flex tw-items-center tw-gap-2">
    <div class="tw-justify-start tw-items-center tw-flex">
      <div class="tw-justify-start tw-items-start tw-flex">
        <div class="tw-w-6 tw-h-6 tw-relative"></div>
      </div>
      <div class="tw-p-2 tw-justify-start tw-items-center tw-gap-4 tw-flex">
        <div class="tw-w-6 tw-h-6 tw-relative">
          <cohrex-svg name="bell"></cohrex-svg>
        </div>
        <div class="tw-relative tw-inline-block tw-text-left">
          <cohrex-language-switcher />
        </div>
      </div>
    </div>
  </div>
</div>
